import { UserInput } from '../../../../../types/registration/userInput';

export interface UserInputValidationResult {
  hasConstructionDensityData: boolean;
  hasDoors: boolean;
  hasFloorData: boolean;
  hasRoofData: boolean;
  hasShapeAndDirectionData: boolean;
  hasWallData: boolean;
  hasWindows: boolean;
}

export const useUserInputValidation = (userInput: UserInput | undefined): UserInputValidationResult => {
  if (!userInput) {
    return {
      hasConstructionDensityData: false,
      hasDoors: false,
      hasFloorData: false,
      hasRoofData: false,
      hasShapeAndDirectionData: false,
      hasWallData: false,
      hasWindows: false
    };
  }

  const bygningsdetaljer = userInput.bygningsdetaljer;

  return {
    hasConstructionDensityData: !!bygningsdetaljer?.konstruksjonstetthet,
    hasDoors: !!bygningsdetaljer?.ytterDorer && bygningsdetaljer.ytterDorer.length > 0,
    hasFloorData:
      bygningsdetaljer?.etasjer?.some((etasje) =>
        etasje.gulvSoner?.some(
          (gulvsone) =>
            gulvsone.arealIKvm ||
            gulvsone.tilliggendeRom ||
            (gulvsone.gulvKonstruksjon && Object.values(gulvsone.gulvKonstruksjon).length > 0)
        )
      ) ?? false,
    hasRoofData: !!bygningsdetaljer?.tak,
    hasShapeAndDirectionData:
      bygningsdetaljer?.etasjer?.some(
        (etasje) =>
          etasje.gjennomsnittligEtasjehoyde ||
          etasje.bygningsForm ||
          etasje.vegger?.some((vegg) => vegg.himmelretning || vegg.lengdeIMeter)
      ) ?? false,
    hasWallData:
      bygningsdetaljer?.etasjer?.some((etasje) =>
        etasje.vegger?.some((vegg) =>
          vegg.veggSoner?.some(
            (veggsone) =>
              veggsone.tilliggendeRom ||
              veggsone.lengdeIMeter ||
              (veggsone.veggKonstruksjon && Object.values(veggsone.veggKonstruksjon).length > 0)
          )
        )
      ) ?? false,
    hasWindows:
      bygningsdetaljer?.etasjer?.some((etasje) =>
        etasje.vegger?.some((vegg) =>
          vegg.veggSoner?.some((veggsone) => veggsone.vinduer && veggsone.vinduer.length > 0)
        )
      ) ?? false
  };
};
